import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CF9B4635-FE27-4DA5-BE51-F5F4116AFC54
 * name page-last
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-last.svg
 * tags
 */
export const PageLastIcon = createSvgIcon(<><path d="M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z" /></>, 'PageLastIcon');
export default PageLastIcon